import {RequestInfo} from "@khan/shared-core";

/**
 * Determine if we might running inside an integration or not.
 *
 * @returns {boolean} `true` if we might be in an integration; `false`
 * otherwise.
 */
export const couldBeIntegration = () =>
    RequestInfo.isMobileApp || RequestInfo.isExtension;
